import React from 'react';
import './DisasterPreparedness.css';

const DisasterPreparedness = () => {
  return (
    <section className="disaster-preparedness">
      <div className="disaster-wrapper">
        <h2 className="section-title">Disaster Preparedness</h2>
        <p>
          The local government has implemented proactive strategies for managing emergencies such as
          floods, fires, and health outbreaks. Training programs and awareness campaigns are regularly
          conducted to keep our citizens informed and prepared.
        </p>
      </div>
    </section>
  );
};

export default DisasterPreparedness;